module.exports = __webpack_public_path__ + "static/media/Album 4.0058e8db.png";